import React, { useEffect, useState } from "react";
import "./QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AllQuestionRequired from "../../../../DcmDetails/SelfAssessment/Popup/AllQuestionRequired";
import ConfirmPopup from "./ConfirmPopup";
import UnattemptedQsPopup from "./UnattemptedQsPopup";
import {
  Paper,
  Box,
  Grid,
  Typography,
  Button,
  Stack,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UnSaveChangesPopup from "./UnSaveChangesPopup";

export default function AllQuestions({ type }) {
  const { homeworkId, selfAssessmentId } = useParams();
  const [unsavedHwAswer, setUnsavedHwAnswer] = useState({});

  const { state } = useLocation();
  const [pendingData, setPendingData] = useState();
  const [isGettingData, setIsGettingData] = useState(true);
  const [isSubmitProcessing, setIsSubmitProcessing] = useState(false);
  const [finalAttachment, setFinalAttachment] = useState([]);
  const [isNotAllQuestionAnswered, setIsNotAllQuestionAnswered] =
    useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  const [confirmPopupOpen, setConfirmPopupOpen] = useState(false);
  const [unAttemptedQsHwArray, setUnAttemptedQsHwArray] = useState([]);
  const [unAnsweredHwQs, setUnansweredHwQs] = useState([]);
  const [unAnsweredPopup, setUnAnsweredPopup] = useState(false);
  const [unsavedChangesPopup, setUnsavedChangesPopup] = useState(false);
  const navigate = useNavigate();
  const receiveDataFromChild = (data) => {
    setFinalAttachment(data);
  };
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const getHWQuestionResponse = async () => {
    try {
      let updatedQuestion = [];
      let tempAllQuestion = [];
      let res = await axios.get(`/homework/get/${state.homeworkId}`);
      res &&
        res.data.data?.questions.forEach((question, index) => {
          tempAllQuestion.push(question);
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              question_id: question?.id,
              answer: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              question_id: question?.id,
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
      setAllQuestions(tempAllQuestion);
      setQuestionsAnswer([...updatedQuestion]);
      res && setPendingData(res.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
      setIsGettingData(false);
    }
  };

  const getSAQuestionResponse = async () => {
    try {
      let updatedQuestion = [];
      let tempAllQuestion = [];
      let res = await axios.get(`/selfAssess/get/${state.selfAssessmentId}`);
      if (
        res.data.data?.questions.length == 0 &&
        res.data.data?.b4sQuestions.length == 0
      ) {
        toast.info("Qustions not available");
        navigate(-1);
      }
      if (res) {
        res.data.data?.questions.forEach((question, index) => {
          tempAllQuestion.push(question);
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              questionSource: "question",
              question_id: question?.id,
              answer: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              questionSource: "question",
              question_id: question?.id,
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
        res.data.data?.b4sQuestions.forEach((question, index) => {
          tempAllQuestion.push(question);
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              questionSource: "b4s",
              question_id: question?.id,
              answer: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              questionSource: "b4s",
              question_id: question?.id,
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
      }
      setAllQuestions(tempAllQuestion);
      setQuestionsAnswer([...updatedQuestion]);
      res && setPendingData(res.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (type == "HW") {
      getHWQuestionResponse();
    } else if (type == "SA") {
      getSAQuestionResponse();
      // console.log("SA api not defined")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [questionNo, setQuestionNo] = useState(0);
  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleSucessfulyfalse = () => {
    setAllQuestion({
      ...allQuestion,
      sucessful: false,
    });
  };

  const [questionsAnswer, setQuestionsAnswer] = useState([]);

  const handleSubmit = async (assessmentId, assessmentType) => {
    // setIsSubmitProcessing(true);
    try {
      if (unAttemptedTitles.length > 0) {
        setUnAnsweredPopup(true);
        return;
      } else {
        setConfirmPopupOpen(true)
      }
      if (type == "SA") {
        let notAnswer = questionsAnswer.filter(
          (answer) => answer.answer.key == " "
        );
        if (notAnswer.length > 0) {
          setIsNotAllQuestionAnswered(true);
          return;
        }

        let qustionAnswer = [];
        let b4sQuestionAnswer = [];
        questionsAnswer.map((answer) => {
          if (answer.questionSource == "b4s") {
            delete answer.questionSource;
            b4sQuestionAnswer.push(answer);
          } else if (answer.questionSource == "question") {
            delete answer.questionSource;
            qustionAnswer.push(answer);
          }
        });
        if (type == "SA") {
          let selfAssessmentBody = {
            student_id: userId,
            submitted_on: new Date(),
            questionanswers: qustionAnswer,
            b4squestionanswers: b4sQuestionAnswer,
          };
          let res = await axios.post(
            `/${assessmentType}/${assessmentId}/studentResponse/create`,
            selfAssessmentBody
          );
          res && setAllQuestion({ ...allQuestion, sucessful: true });
        } else {
          let selfAssessmentBody = {
            student_id: userId,
            submitted_on: new Date(),
            answers: questionsAnswer,
          }
          let res = await axios.post(
            `/${assessmentType}/${assessmentId}/studentResponse/create`,
            selfAssessmentBody
          );

          res && setAllQuestion({ ...allQuestion, sucessful: true });
        }
      } else {
        let selfAssessmentBody = {
          student_id: userId,
          submitted_on: new Date(),
          answers: questionsAnswer,
        };
        console.log("selfAssessmentBody", selfAssessmentBody);

        let res = await axios.post(
          `/${assessmentType}/${assessmentId}/studentResponse/create`,
          selfAssessmentBody
        );
        if (res.status === 201) {
          setAllQuestion({ ...allQuestion, sucessful: true });
          const allHomeworks =
            JSON.parse(localStorage.getItem("homeworkAnswers")) || {};

          if (unsavedHwAswer?.student_id === userId) {
            delete allHomeworks[pendingData?.id];
            localStorage.setItem(
              "homeworkAnswers",
              JSON.stringify(allHomeworks)
            );
          }
          setUnsavedChangesPopup(false);
          setQuestionsAnswer([]);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message ?? "Something went wrong");
      console.log(error);
    } finally {
      setConfirmPopupOpen(false);
    }
    setIsSubmitProcessing(false);
  };



  let From = localStorage.getItem("From");

  const checkUnanswered = () => {
    // current question pick karo
    const currentQuestion = questionsAnswer[questionNo];

    let pendingCurrentQs;

    if (type === "SA") {
      pendingCurrentQs = pendingData?.b4sQuestions[questionNo];
    } else {
      pendingCurrentQs = pendingData?.questions[questionNo];
    }

    setUnAttemptedQsHwArray((prev) => {
      const exists = prev.some((item) => item.id === pendingCurrentQs?.id);

      if (exists) return prev;

      return [
        ...prev,
        {
          id: pendingCurrentQs?.id,
          title: `Q${questionNo + 1}. ${pendingCurrentQs?.title}`,
        },
      ];
    });

    if (
      currentQuestion?.answer?.key === " " ||
      currentQuestion?.answer?.key === "" ||
      currentQuestion?.description === " " ||
      currentQuestion?.description === ""
    ) {
      setUnansweredHwQs((prev) => [...prev, currentQuestion]);
    } else {
      setUnansweredHwQs((prev) =>
        prev.filter((q) => q.index !== currentQuestion.index)
      );
    }
  };

  useEffect(() => {
    const savedData = localStorage.getItem("homeworkAnswers");

    if (savedData) {
      const allHomeworks = JSON.parse(savedData);
      const unsavedAnswer = allHomeworks[pendingData?.id];
      setUnsavedHwAnswer(unsavedAnswer);

      if (unsavedAnswer) {
        setUnsavedChangesPopup(true);
      }
    }
  }, [pendingData?.id]);

  const handleRestoreAnswers = () => {
    if (
      unsavedHwAswer?.student_id === userId &&
      unsavedHwAswer &&
      Array.isArray(unsavedHwAswer?.answers)
    ) {
      if (type === "HW") {
        setQuestionsAnswer(unsavedHwAswer?.answers);
      }
    }
    setUnsavedChangesPopup(false);
  };

  const handleIgnoreAnswers = () => {
    const allHomeworks =
      JSON.parse(localStorage.getItem("homeworkAnswers")) || {};

    if (unsavedHwAswer?.student_id === userId) {
      delete allHomeworks[pendingData?.id];
      localStorage.setItem("homeworkAnswers", JSON.stringify(allHomeworks));
    }
    setUnsavedChangesPopup(false);
    setQuestionsAnswer([]);
  };

  const saveAnswersToLocalStorage = (newAnswers, homeworkId) => {
    const existingData = localStorage.getItem("homeworkAnswers");
    let allHomeworks = {};

    try {
      allHomeworks = existingData ? JSON.parse(existingData) : {};
    } catch (e) {
      console.error("Invalid JSON in localStorage, resetting...");
      allHomeworks = {};
    }

    // get or create homework entry
    const storedData = allHomeworks[homeworkId] || {
      student_id: userId,
      submitted_on: new Date(),
      answers: [],
    };

    // merge new answers
    const mergedAnswers = [
      ...storedData.answers.filter(
        (old) => !newAnswers.some((n) => n.question_id === old.question_id)
      ),
      ...newAnswers,
    ];

    // update this homework
    allHomeworks[homeworkId] = {
      student_id: userId,
      submitted_on: new Date(),
      answers: mergedAnswers,
    };

    // write everything back
    localStorage.setItem("homeworkAnswers", JSON.stringify(allHomeworks));
  };

  const unAttemptedTitles = unAttemptedQsHwArray
    .filter((item) => unAnsweredHwQs.some((q) => q.question_id === item.id))
    .map((item) => item.title);

  return (
    <>
      {pendingData && allQuestions.length > 0 ? (
        <Box display="flex" mb={2}>
          <Box>
            <IconButton
              onClick={() => {
                From === "DCM" ? navigate("/Calender") : navigate(-1);
              }}
              size="large"
            >
              <ArrowBackIcon fontSize="large" />
            </IconButton>
          </Box>
          {/* <div className="hederContainer1">
            <div>
              <div className="d-flex justify-content-between w-100  ">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: "1200px",
                    wordWrap: "break-word",
                  }}
                >
                  <span
                    className="quesHeading"
                    style={{
                      fontWeight: 600,
                      fontSize: "16px",
                      lineHeight: "24px",
                      color: "#000a11",
                      whiteSpace: "normal", // allow wrapping
                    }}
                  >
                    {pendingData?.name}
                  </span>
                </div>

                <div>
                  <div style={{ textAlign: "right" }}>
                    <span className="subTitles">Total Marks</span> &nbsp;
                    <span className="quesHeading">
                      {pendingData?.total_marks}
                    </span>
                  </div>
                  <div>
                    <span className="subTitles">This Question</span> &nbsp;
                    <span className="quesHeading">
                      {allQuestions[questionNo]?.correct_score}
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 mt-1">
                {type == "SA" ? (
                  <div>
                    <span className="subTitle2">
                      {pendingData?.subject?.name}
                    </span>{" "}
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Created</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(pendingData?.created_at)}
                    </span>
                  </div>
                ) : (
                  <div>
                    <span className="subTitle2">
                      {pendingData?.subject_id?.name}
                    </span>
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Deadline</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(pendingData?.deadline)}
                    </span>
                  </div>
                )}
                <div className="subTitle2">
                  Questions: {questionNo + 1}/{allQuestions?.length}
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "500",
                margin: "15px 0px",
              }}
            >
              {pendingData?.description}
            </div>
            <div className="mt-3 d-flex gap-2">
              {allQuestions?.length > 0 &&
                allQuestions?.map((item, index) => {
                  const isUnanswered = unAnsweredHwQs.some(
                    (q) => q.index === index
                  );
                  return (
                    <div
                      onClick={(e) => {
                        checkUnanswered();
                        setQuestionNo(index);
                      }}
                      className={
                        isUnanswered
                          ? "QuestionNoAnswerQs" // ✅ unanswered ka special class
                          : questionNo > index
                          ? "QuestionActiveNo"
                          : "QuestionNoNonActive"
                      }
                      style={{
                        borderColor: isUnanswered
                          ? "#FFE100" // ✅ unanswered ka border
                          : item.is_mandatory
                          ? "#AC1616"
                          : questionNo === index
                          ? "#F99933"
                          : questionNo > index
                          ? "#F77F00"
                          : "#668598",

                        color: isUnanswered
                          ? "#F77F00" // ✅ unanswered text color
                          : questionNo === index
                          ? "#F99933"
                          : questionNo > index
                          ? "#F77F00"
                          : "#668598",

                        backgroundColor: isUnanswered
                          ? "#FFE100" // ✅ unanswered background (light yellow)
                          : questionNo > index
                          ? "#FEF2E5"
                          : "transparent",

                        minWidth: "30px",
                      }}
                    >
                      Q{index + 1}
                    </div>
                  );
                })}
            </div>

            <div
              className="mt-4 allquestionTypesContainer"
              style={{ height: "83%" }}
            >
              {!allQuestions[questionNo]?.type?.is_manually_graded ? (
                <CheckBoxType
                  questionNo={questionNo + 1}
                  question={allQuestions[questionNo]}
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                />
              ) : (
                <SubmisshionByUpload
                  receiveDataFromChild={receiveDataFromChild}
                  questionNo={questionNo + 1}
                  question={allQuestions[questionNo]}
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                />
              )}

              <div
                className="d-flex gap-2 justify-content-end"
                style={{ marginRight: "26px" }}
              >
                {questionNo >= 1 && (
                  <button
                    className="PreviousBtnQue"
                    onClick={(e) => setQuestionNo(questionNo - 1)}
                  >
                    Previous
                  </button>
                )}

                {allQuestions?.length > questionNo + 1 ? (
                  <button
                    className="nextBtnQue"
                    onClick={(e) => {
                      checkUnanswered();
                      setQuestionNo(questionNo + 1);
                    }}
                  >
                    Next
                  </button>
                ) : (
                  <button
                    className={`nextBtnQue ${
                      isSubmitProcessing ? "disabled" : ""
                    }`}
                    disabled={isSubmitProcessing}
                    onClick={() => {
                      setConfirmPopupOpen(true);
                      checkUnanswered();
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div> */}
          <Paper
            elevation={3}
            sx={{
              p: 2,
              borderRadius: 2,
              backgroundColor: "#f9f9f9",
              width: "96%",
            }}
          >
            {/* Header: Question Name & Marks */}
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Grid item xs={7}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#000a11",

                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={pendingData?.name}
                >
                  {pendingData?.name}
                </Typography>
              </Grid>

              <Grid
                item
                xs={5}
                sx={{
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.5,
                }}
              >
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Total Marks
                  </Typography>{" "}
                  <Typography
                    variant="subtitle1"
                    component="span"
                    fontWeight={600}
                  >
                    {pendingData?.total_marks}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    This Question
                  </Typography>{" "}
                  <Typography
                    variant="subtitle1"
                    component="span"
                    fontWeight={600}
                  >
                    {allQuestions[questionNo]?.correct_score}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* Subject + Created/Deadline + Question count */}
            <Grid container justifyContent="space-between" mt={1}>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  {type === "SA"
                    ? `${pendingData?.subject?.name} | Created: ${timeHelper(
                      pendingData?.created_at
                    )}`
                    : `${pendingData?.subject_id?.name
                    } | Deadline: ${timeHelper(pendingData?.deadline)}`}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Questions: {questionNo + 1}/{allQuestions?.length}
                </Typography>
              </Grid>
            </Grid>

            {/* Description */}
            <Box mt={2}>
              <Typography variant="body1">
                {pendingData?.description}
              </Typography>
            </Box>

            {/* Question Navigation */}
            <Stack
              direction="row"
              spacing={1}
              mt={2}
              sx={{
                overflowX: 'auto',
                flexWrap: 'nowrap',
                pb: 1,
                // Custom scrollbar styling
                '&::-webkit-scrollbar': {
                  height: '6px',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                  borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#888',
                  borderRadius: '3px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#555',
                },
                // Firefox scrollbar
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              {allQuestions?.map((item, index) => {
                const isUnanswered = unAnsweredHwQs.some(
                  (q) => q.index === index
                );
                return (
                  <Button
                    key={index}
                    variant={questionNo === index ? "contained" : "outlined"}
                    color={isUnanswered ? "warning" : "primary"}
                    size="small"
                    sx={{
                      minWidth: "30px",
                      fontWeight: 600,
                      flexShrink: 0,         // Prevent buttons from shrinking
                      backgroundColor: isUnanswered
                        ? "#FFE100"
                        : questionNo > index
                          ? "#FEF2E5"
                          : "transparent",
                      borderColor: isUnanswered
                        ? "#FFE100"
                        : questionNo > index
                          ? "#F77F00"
                          : "#0000",
                      color: isUnanswered ? "#F77F00" : "#000",
                    }}
                    onClick={() => {
                      checkUnanswered();
                      setQuestionNo(index);
                    }}
                  >
                    Q{index + 1}
                  </Button>
                );
              })}
            </Stack>

            {/* Question Content */}
            <Box mt={3} height="83%">
              {!allQuestions[questionNo]?.type?.is_manually_graded ? (
                <CheckBoxType
                  questionNo={questionNo + 1}
                  question={allQuestions[questionNo]}
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                  pendingData={pendingData}
                  saveAnswersToLocalStorage={saveAnswersToLocalStorage}
                />
              ) : (
                <SubmisshionByUpload
                  receiveDataFromChild={receiveDataFromChild}
                  questionNo={questionNo + 1}
                  question={allQuestions[questionNo]}
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                  pendingData={pendingData}
                  saveAnswersToLocalStorage={saveAnswersToLocalStorage}
                />
              )}

              {/* Navigation Buttons */}
              <Stack
                direction="row"
                spacing={2}
                justifyContent="flex-end"
                mt={2}
              >
                {questionNo >= 1 && (
                  <Button
                    variant="outlined"
                    onClick={() => setQuestionNo(questionNo - 1)}
                  >
                    Previous
                  </Button>
                )}

                {allQuestions?.length > questionNo + 1 ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      checkUnanswered();
                      setQuestionNo(questionNo + 1);
                    }}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    disabled={isSubmitProcessing}
                    onClick={() => {
                      setConfirmPopupOpen(true);
                      checkUnanswered();
                    }}

                  >
                    Submit
                  </Button>
                )}
              </Stack>
            </Box>
          </Paper>

          {allQuestion.sucessful && (
            <SucessfullySubmited
              type={type}
              handleSucessfulyfalse={handleSucessfulyfalse}
            />
          )}
          {isNotAllQuestionAnswered && (
            <AllQuestionRequired
              setIsNotAllQuestionAnswered={setIsNotAllQuestionAnswered}
            />
          )}
          {confirmPopupOpen && (
            <ConfirmPopup
              setConfirmPopupOpen={setConfirmPopupOpen}
              type={type}
              handleSubmit={handleSubmit}
              state={state}
            />
          )}
          {unAnsweredPopup && (
            <UnattemptedQsPopup
              setUnAnsweredPopup={setUnAnsweredPopup}
              unAttemptedTitles={unAttemptedTitles}
              setConfirmPopupOpen={setConfirmPopupOpen}
              questionsAnswer={questionsAnswer}
              setAllQuestion={setAllQuestion}
              setIsNotAllQuestionAnswered={setIsNotAllQuestionAnswered}
              type={type}
              state={state}
              allQuestion={allQuestion}
              userId={userId}
            />
          )}
          {unsavedChangesPopup && (
            <UnSaveChangesPopup
              pendingData={pendingData}
              setUnsavedChangesPopup={setUnsavedChangesPopup}
              handleRestoreAnswers={handleRestoreAnswers}
              handleIgnoreAnswers={handleIgnoreAnswers}
              unsavedChangesPopup={unsavedChangesPopup}
            />
          )}
        </Box>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center h-20 align-items-center w-100">
          <span
            className="px-2 py-2 d-flex align-items-center gap-2"
            style={{ fontSize: "1.2rem", fontWeight: 500 }}
          >
            {type == "SA" ? "Self-Assessment " : "Homework "} Not Found
          </span>
        </div>
      )}
    </>
  );
}
